var e = {
  help: "Help",
  "my-account": "My Account",
  "kaseya-com": "Kaseya.com",
  "app-launcher": "App Launcher",
  "whats-new": "What's New",
  "learn-more": "Learn More",
  "sso-title": "Single Sign-On",
  "sso-no-access": "You do not have access to SSO. Contact your Admin to enable Log In with KaseyaOne.",
  "sso-enabled": "Your Admin has enabled single sign-on.",
  "login-with-k1": "Log In with KaseyaOne",
  "enable-login-with-k1": "Enable Log In with KaseyaOne",
  "enable-login-with-k1-description": "Once enabled, your users can enable Log In with KaseyaOne for themselves."
};
export { e as default };